import React, {FC, useCallback, useEffect, useState} from "react";

import Typography from "@material-ui/core/Typography";
import {
    IControlMeasure,
    IControlMeasureCost,
    IControlMeasureFailureMode,
    IDam, IDocument,
    IFNCurve, IFNData,
    IProjectFailureMode
} from "../types/types";
import {
    Accordion,
    AccordionSummary,
    Button,
    Card,
    CardActions,
    CardContent,
    Grid, Paper, Table, TableCell,
    TableContainer, TableHead
} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import EChartsReact from "echarts-for-react";
import {get} from "../fetchers/fetchers";
 
import {useParams} from "react-router";
import {ExpandMore, Height} from "@material-ui/icons";
import ControlMeasureCost from "./control_measure_cost";
import FNCurveUpload from "./fn_curve_upload";
import { API_URL , APPLICATION} from "../env";
import CircularProgress from "@material-ui/core/CircularProgress";

interface IRouteParams {
    id: string
}

interface IData {
    name: string
    data: number[][]
    type: string
}


interface IFMChartProps {

}



const FMChart: FC<IFMChartProps> = () => {
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [controlMeasures, setControlMeasures] = useState<IControlMeasure[]>([]);
    const [failureModes, setFailureModes] = useState<IProjectFailureMode[]>([]);
    const [fncurves, setIFNCurves]= useState<IFNCurve[]>([]);
    const [ifnData, setIfnData] = useState<IFNData[]>([]);
    const [data, setData] = useState<IData[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [updateData, setUpdateData] = useState<boolean>(false);
    const [maxN, setMaxN] = useState<number>(10000);

    const [controlMeasureFailureModes, setControlMeasureFailureModes] = useState<IControlMeasureFailureMode[]>([]);

    const params = useParams<IRouteParams>()

    const getFailureModes = async () => {
        const d = await get<IProjectFailureMode[]>( API_URL + "failure_modes/" + params.id.toString());
        setFailureModes(d)
    }

    const getFailureModeControlMeasures = async () => {
        const d = await get<IControlMeasureFailureMode[]>( API_URL + "control_measures/" + params.id.toString() + "/failure_modes");
        setControlMeasureFailureModes(d)
    }
    const getControlMeasures = async () => {
        const assessments = await get<IControlMeasure[]>( API_URL + "control_measures/" + params.id + "/");
        setControlMeasures(assessments)
    }

    const getFNCurves = async () => {
        const fncurves = await get<IFNCurve[]>( API_URL + "fn/" + params.id + "/");
        setIFNCurves(fncurves)
    }

    const getFNData= async () => {
        const fnData = await get<IFNData[]>( API_URL + "fn/" + params.id + "/data");
        setIfnData(fnData)

    }

    const getFnCurve = (cm: IControlMeasure): IFNCurve => {
        let cm_id = cm.uuid
        if (!cm_id)
            cm_id = -1
        let fncurve = fncurves.find(cma => cma.control_measure_id === cm_id)


        if (fncurve) {
            return fncurve
        }
        return {
            control_measure_id: cm_id,
            is_existing: false
        }

    }


    const generateData = () => {
        let series:IData[] = []
        series.push({
            name: APPLICATION=="ALARP" ? "Limit of Tolerability": "Safety Threshold",
            data: [[0.01, 0.1],[maxN, 0.001/maxN]],
            type: 'line'
        })

        fncurves.map( (f) => {
            // linear e

            let data:number[][] = [];


            let cm = controlMeasures.find( (cm) => cm.uuid === f.control_measure_id)
            let vd = ifnData.filter( (i) => i.cn_curve_id === f.id );

            vd.forEach( (d) => {
                if (d.f > maxN) {
                    setMaxN(maxN * 10)
                }
                data.push([d.f, d.n])
            })

            series.push(
                {
                    "name": cm ? cm.description : "Existing" ,
                    "type": "line",
                    "data": data
                }
            )


        })
        setData(series)
    }

    const updateFNCurve = useCallback(() => {
        setIsLoaded(false)
    }, [setIsLoaded]);


    useEffect(() => {
        if (!isLoaded && !isLoading) {
            setData([])
            setIsLoading(true)
            getFNCurves().then(
                () => {
                    getControlMeasures().then(
                        () => {
                            getFailureModes().then(
                                () => {
                                    getFailureModeControlMeasures().then(
                                        () => {
                                            getFNData().then(
                                                (a) => {
                                                    setIsLoaded(true)
                                                    setIsLoading(false)
                                                    setUpdateData(true)

                                                }
                                            )

                                        }
                                    )
                                }
                            )
                        }
                    )
                }
            )
        }
        if (updateData) {

            generateData()
            setUpdateData(false)
        }


    }, [isLoaded,isLoading, setIsLoaded, ifnData, updateData]);

    const getOption = () => {

        return {
            toolbox: {
                show: true,
                feature: {
                    dataZoom: {
                        yAxisIndex: 'none'
                    },
                    dataView: {readOnly: false},
                    saveAsImage: {}
                }
            },
            xAxis: {
                name: 'N',
                type: 'log',
                minorTick: {
                    show: true
                },
                min: 0.01,
                max: maxN,
                minorSplitLine: {
                    show: true
                }
            },
            legend: {
                type: 'scroll',
                orient: 'vertical',
                top: 50,
                left: 500,
                height: 600
            },
            grid: {
                left: 100,
                bottom: 0,
                top: 50,
                width: 360,
                height: 500,
                containLabel: false
              },
            yAxis: {
                type: 'log',
                name: 'F',
                min: 1e-10,
                max: 0.1,
                minorTick: {
                    show: true
                },
                minorSplitLine: {
                    show: true
                },
                axisLabel: {
                    formatter: function (val: number) {
                        return (val).toExponential();
                    }
                },
            },
            series : data
         }
    }

    let all_existing_cm : IControlMeasure = {
        uuid: -1,
        description: "Existing dam",
        existing: true,
        control_type_id: -1
    }
    let all_additional_cm : IControlMeasure = {
        uuid: -2,
        description: "All additional control measures",
        existing: false,
        control_type_id: -1
    }

    return (<>
    {!isLoaded && <><br /> <CircularProgress style={{ marginLeft: "10px", marginRight: "10px", color: "#969697" }} /></>}
            {isLoaded &&  <EChartsReact option={getOption()} style={{height: "600px"}}/>}
            {
                <Grid container xs={12} lg={12} style={{padding: 10, width: "100%"}}>
                <Paper variant={"outlined"}
                       style={{display: "flex", flexDirection: "column", height: "100%", margin: "10px", flex: 1}}>
                    {isLoaded &&
                    <TableContainer style={{overflowX: "auto", maxWidth: "95vw"}}>
                        <Table>
                            <TableHead>
                                <TableCell><b>Control Measure</b></TableCell>
                                <TableCell><b>Upload</b></TableCell>
                            </TableHead>

                            <FNCurveUpload control_measure={all_existing_cm}
                                           fn_curve={getFnCurve(all_existing_cm)}
                                           updateFNCurve={updateFNCurve}
                            />
                            <FNCurveUpload control_measure={all_additional_cm}
                                           fn_curve={getFnCurve(all_additional_cm)}
                                           updateFNCurve={updateFNCurve}
                            />

                            { controlMeasures.map( (cm) =>
                            {
                                    return (
                                        <FNCurveUpload control_measure={cm}
                                                       fn_curve={getFnCurve(cm)}
                                                       updateFNCurve={updateFNCurve}
                                        />
                                    )
                                })
                            }

                        </Table>
                    </TableContainer>
                    }
                </Paper>
            </Grid>}
        </>
    );
}

export default FMChart;
